const state = {
    initialPlaylistIndex: -1,
    contentType: 'video',
    previousPosition: null,
    previousVideo: null,
    previewFinished: false,
};

const mutations = {
    initialPlaylistIndex(state, index) {
        state.initialPlaylistIndex = index;
    },
    updateContentType(state, type) {
        state.contentType = type;
    },
    updatePreviousPosition(state, position) {
        state.previousPosition = position;
    },
    previousVideo(state, index) {
        state.previousVideo = index;
    },
    previewFinished(state, finished) {
        state.previewFinished = finished;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
}
